<script setup lang="ts">
import { vOnClickOutside } from '@vueuse/components'

import { useProfileStore } from '@stores/profile'

import { useUserMenu } from '@hooks/auth/use-user-menu.hook'

import UserMenuAvatar from '@Molecules/Auth/UserMenuAvatar.vue'
import { ListDropdown } from '@UI/Other/ListDropdown'
import { ItemDropdown } from '@UI/Other/ItemDropdown'

defineOptions({
  name: 'UserMenu',
})

const profileStore = useProfileStore()

const {
  refIsShown,
  setShown,
  handleClickOutside,
  setRedirectToProfile,
  setLogout,
} = useUserMenu()
</script>

<template>
  <div
    v-on-click-outside="handleClickOutside"
    class="user-menu"
  >
    <div
      class="user-menu__general"
      :title="profileStore.getUser?.name"
      @click="setShown(!refIsShown)"
    >
      <UserMenuAvatar />
    </div>
    <ListDropdown v-if="refIsShown">
      <ItemDropdown
        text="Profile"
        @click="setRedirectToProfile"
      />
      <ItemDropdown
        text="Logout"
        @click="setLogout"
      />
    </ListDropdown>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Auth/UserMenu.scss" />
